import _ from 'lodash'
import { Base64 } from 'js-base64'

let JSONParse = JSON.parse
let Base64Decode = Base64.decode
const base64url = require('base64-url')

export const Base64UrlEncode = (str) => {
  return base64url.encode(str)
}

/**
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy (obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }
  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }
  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })
  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })
  return copy
}

/**
 * forEach for object
 */
export function forEachValue (obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

/**
 * delNullObject
 * @desc 删除object 中key 为null的值
 * @return 新对象
 */
export function delNullObject (obj) {
  let copy = deepCopy(obj)
  _.forOwn(copy, (val, key, obj) => {
    if (val == null) {
      delete obj[key]
    }
  })
  return copy
}

/**
 * delNullObject
 * @desc 删除object 中key 为 '' 的值
 * @return 新对象
 */
export function delEmptyStr (obj) {
  let copy = deepCopy(obj)
  _.forOwn(copy, (val, key, obj) => {
    if (val === '') {
      delete obj[key]
    }
  })
  return copy
}

/**
 * 获取字符串真实长度 汉字算两位
 * @param str
 * @returns {number}
 */
let dubbleStrRE = /[^\u4E00-\u9FA5]/g

export function getLocalLen (str) {
  return _.isEmpty(str) ? 0 : str.replace(dubbleStrRE, '**').length
}

export function substrLen (str, len, fix) {
  return (typeof str === 'string' && getLocalLen(str) > len) ? (str.substring(0, len) + (fix !== undefined ? fix : '...')) : str
}

export function getUrlParam (url, name) {
  console.log(url)
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = url.split('?')[1].match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export function concatList (arr1, arr2) {
  let arr3 = arr1.concat(arr2), // 合并成一个数组
    temp = {}, // 用于id判断重复
    result = [] // 最后的新数组
  // 遍历c数组，将每个item.id在temp中是否存在值做判断，如不存在则对应的item赋值给新数组，并将temp中item.id对应的key赋值，下次对相同值做判断时便不会走此分支，达到判断重复值的目的
  arr3.map((item, index) => {
    if (!temp[item.id]) {
      result.push(item)
      temp[item.id] = true
    }
  })
  console.log(result)
  return result
}

export const headersKeysLowerCase = (headers) => {
  return _.mapKeys(headers, (val, key) => {
    return key.toLowerCase()
  })
}

export const hasPageCount = (headers) => {
  let _headers = headersKeysLowerCase(headers)
  let count = _headers['x-pagination-total-count']
  return (typeof count === 'string' || typeof count === 'number') && count >= 0
}

export const getTotalCount = (headers) => {
  let _headers = headersKeysLowerCase(headers)
  return parseInt(_headers['x-pagination-total-count'])
}

export const hasNextPage = (headers) => {
  let _headers = headersKeysLowerCase(headers)
  return parseInt(_headers['x-pagination-total-count']) > parseInt(_headers['x-pagination-current-page'])
}

// debug
export const isDebugMode = () => {
  return localStorage.getItem('tx_debug')
}

// log
export const log = (function () {
  if (isDebugMode()) {
    return console.log
  } else {
    return () => {
    }
  }
})()

// 数据加密
export const Base64Encode = (str) => {
  return typeof str === 'object' ? Base64.encode(JSON.stringify(str)) : Base64.encode(str)
}
// JSON.parse 数据解密
export const parseBase64 = (base64str) => {
  try {
    return JSONParse(Base64Decode(base64str))
  } catch (e) {
    console.error('json 数据解析异常:', e)
  }
}

// 一个数组里有多个对象，根据对象某个相同属性，重新组成新数组
export const objectToArray = (arr, key) => {
  let types = []
  for (let i in arr) {
    if (types.indexOf(arr[i][key]) === -1) {
      types.push(arr[i][key])
    }
  }
  // 一个包含多个list的结果对象
  let obj = {}
  
  // 根据type生成多个数组
  for (let k in types) {
    for (let j in arr) {
      if (arr[j][key] == types[k]) {
        obj[types[k]] = obj[types[k]] || []
        obj[types[k]].push(arr[j])
      }
    }
  }
  return obj
}
